
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CustomDatePicker',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      dateFrom: {
        type: String,
        default: '',
      },
      dateTo: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: 'Select Date Range',
      },
      maxDate: {
        type: String,
        default: () => new Date().toISOString().split('T')[0],
      },
    },
    emits: ['update:dateFrom', 'update:dateTo', 'apply', 'cancel'],
    setup(props, { emit }) {
      const handleDateFromInput = (event: Event) => {
        const target = event.target as HTMLInputElement;
        emit('update:dateFrom', target.value);
      };

      const handleDateToInput = (event: Event) => {
        const target = event.target as HTMLInputElement;
        emit('update:dateTo', target.value);
      };

      const handleApply = () => {
        if (props.dateFrom && props.dateTo) {
          emit('apply', {
            dateFrom: props.dateFrom,
            dateTo: props.dateTo,
          });
        }
      };

      return {
        handleDateFromInput,
        handleDateToInput,
        handleApply,
      };
    },
  });
